import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired/signup")({
  component: () => <div>Hello /signup!</div>,
});
